module.exports = __webpack_public_path__ + "img/stock4.abbf1b49.png";